import { Background } from "@/components/utils/Background";
import { usePadding } from "@/components/utils/Padding";
import useUtils from "@/hooks/useUtils";
import { DESKTOP } from "@/utils/appConstants";
import { MediaPropTypes } from "./propTypes";
import "./styles.scss";

const Media = (props) => {
  const {
    display_media_order: displayMediaOrder,
    media_3d_model_file: media3dModelFile,
    media_3d_model: media3dModel,
    media_alignment: mediaAlignment,
    media_embed: mediaEmbed,
    media_image: mediaImage,
    media_order: mediaOrder,
    media_padding: mediaPadding,
    media_type: mediaType,
    media_video: mediaVideo,
    media_width: mediaWidth,
  } = props;

  const { device } = useUtils();
  const desktop = device === DESKTOP;

  const paddingStyle = usePadding(mediaPadding);

  if (!mediaType) {
    return null;
  }

  const mediaStyle = {
    ...paddingStyle,
    ...(displayMediaOrder && { order: mediaOrder || 0 }),
    ...(mediaAlignment === "top" && { alignSelf: "flex-start" }),
    ...(mediaAlignment === "center" && { alignSelf: "center" }),
    ...(mediaAlignment === "bottom" && { alignSelf: "flex-end" }),
    width: desktop && mediaWidth ? `${mediaWidth}%` : "100%",
  };

  const backgroundProps = {
    background_3d_model_file: media3dModelFile,
    background_3d_model: media3dModel,
    background_embed: mediaEmbed,
    background_image: mediaImage,
    background_type: mediaType,
    background_video: mediaVideo,
  };

  return (
    <div style={mediaStyle} className="media-component">
      <Background asBackground={false} {...backgroundProps} />
    </div>
  );
};

Media.propTypes = MediaPropTypes;

export default Media;
